export enum BusinessType{
  LENDER = 'LENDER',
  ACCOUNTANT = 'ACCOUNTANT',
  BUSINESS_OWNER = 'BUSINESS_OWNER',
  ATTORNEY = 'ATTORNEY',
  FINANCIAL_ADVISER = 'FINANCIAL_ADVISER',
  VALUATION_PROFESSIONAL = 'VALUATION_PROFESSIONAL',
  TRANSACTIONAL_AGENT = 'TRANSACTIONAL_AGENT',
  OTHER = 'OTHER',
  BROKER = 'BROKER',
  SBDC = 'SBDC' // Small Business Development Center (SBDC),
}
